import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {ViCustomerDto} from "./api/dtos";

import ViCustomerGauge from "./vi-customer-gauge";

function AutomatedViCustomerResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<ViCustomerDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: ViCustomerDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <ViCustomerGauge vi={response}/>
            </div>
        )
    }
}


export default AutomatedViCustomerResult;
